import { FlowScreen } from "../../../models/AtticusScreenFlow";
import { OUTCOMES } from "../../../constants";
import {
  GetStartedScreen,
  Outcomes as GetStartedOutcomes,
} from "./GetStartedScreen";
import { FinancialFeelingsScreen } from "./FinancialFeelingsScreen";
import { FinancialExperienceScreen } from "./FinancialExperienceScreen";
import { WhatToDiscussScreen } from "./WhatToDiscussScreen";
import { BeneRelationshipsScreen } from "./BeneRelationshipsScreen";
import { AnythingElseScreen } from "./AnythingElseScreen";
import {
  AnimateYourAnswersScreen,
  Outcomes as YourAnswersOutcomes,
} from "./AnimateYourAnswersScreen";
import { UpdateAssetsScreen } from "./UpdateAssetsScreen";
import { SubmissionScreen } from "./SubmissionScreen";
import { PaymentRequiredScreen } from "./PaymentRequiredScreen";
import { AlreadySubmittedScreen } from "./AlreadySubmitted";

export enum Sections {
  AboutYou = "About you",
  AboutEstate = "About the estate",
  GetConnected = "Get connected",
}
export enum Screens {
  GetStarted = "Get Started",
  AlreadySubmitted = "Already Submitted",
  FinancialFeelings = "Financial Feelings",
  FinancialExperience = "Financial Experience",
  UpdateAssets = "Update Assets",
  WhatToDiscuss = "What To Discuss",
  EstimatedFMVs = "Estimated FMVs",
  BeneRelationships = "Bene Relationships",
  AnythingElse = "Anything Else",
  AnimateAnswers = "Animate Answers",
  PaymentRequiredScreen = "Payment Required",
  SubmissionScreen = "Submission",
}
export const screenFlow: FlowScreen[] = [
  {
    name: Screens.GetStarted,
    section: Sections.AboutYou,
    pathSuffix: "get-started",
    screenComponent: <GetStartedScreen />,
    next: [
      {
        outcome: GetStartedOutcomes.complete,
        screen: Screens.FinancialFeelings,
      },
      {
        outcome: GetStartedOutcomes.alreadySubmitted,
        screen: Screens.AlreadySubmitted,
      },
    ],
    first: true,
  },
  {
    name: Screens.AlreadySubmitted,
    section: Sections.AboutYou,
    pathSuffix: "already-submitted",
    screenComponent: <AlreadySubmittedScreen />,
    next: null,
  },
  {
    name: Screens.FinancialFeelings,
    section: Sections.AboutYou,
    pathSuffix: "financial-feelings",
    screenComponent: <FinancialFeelingsScreen />,
    next: [{ outcome: OUTCOMES.complete, screen: Screens.FinancialExperience }],
  },
  {
    name: Screens.FinancialExperience,
    section: Sections.AboutYou,
    pathSuffix: "financial-experience",
    screenComponent: <FinancialExperienceScreen />,
    next: [{ outcome: OUTCOMES.complete, screen: Screens.UpdateAssets }],
  },
  {
    name: Screens.UpdateAssets,
    section: Sections.AboutEstate,
    pathSuffix: "estate-update-assets",
    screenComponent: <UpdateAssetsScreen />,
    next: [{ outcome: OUTCOMES.complete, screen: Screens.WhatToDiscuss }],
  },
  {
    name: Screens.WhatToDiscuss,
    section: Sections.AboutEstate,
    pathSuffix: "estate-what-to-discuss",
    screenComponent: <WhatToDiscussScreen />,
    next: [{ outcome: OUTCOMES.complete, screen: Screens.BeneRelationships }],
  },
  // {
  //   name: Screens.EstimatedFMVs,
  //   section: Sections.AboutEstate,
  //   pathSuffix: "estate-estimated-fmvs",
  //   screenComponent: <Typography>build out screen</Typography>,
  //   next: [{ outcome: OUTCOMES.complete, screen: Screens.BeneRelationships }],
  // },
  {
    name: Screens.BeneRelationships,
    section: Sections.AboutEstate,
    pathSuffix: "estate-bene-relationships",
    screenComponent: <BeneRelationshipsScreen />,
    next: [{ outcome: OUTCOMES.complete, screen: Screens.AnythingElse }],
  },
  {
    name: Screens.AnythingElse,
    section: Sections.AboutEstate,
    pathSuffix: "estate-anything-else",
    screenComponent: <AnythingElseScreen />,
    next: [{ outcome: OUTCOMES.complete, screen: Screens.AnimateAnswers }],
  },
  {
    name: Screens.AnimateAnswers,
    section: Sections.GetConnected,
    pathSuffix: "compiling-your-answers",
    screenComponent: <AnimateYourAnswersScreen />,
    next: [
      {
        outcome: YourAnswersOutcomes.submission,
        screen: Screens.SubmissionScreen,
      },
      {
        outcome: YourAnswersOutcomes.paymentRequired,
        screen: Screens.PaymentRequiredScreen,
      },
    ],
  },
  {
    name: Screens.SubmissionScreen,
    section: Sections.GetConnected,
    pathSuffix: "submission",
    screenComponent: <SubmissionScreen />,
    next: null,
    completedAll: true,
  },
  {
    name: Screens.PaymentRequiredScreen,
    section: Sections.GetConnected,
    pathSuffix: "payment-required",
    screenComponent: <PaymentRequiredScreen />,
    next: null,
  },
];
